import React from 'react';
import NavMenu from '../Nav/NavMenu';
import Footer from '../footer/Footer';
import EmptySlider from '../sliders/EmptySlider';
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import churchGroupImage from "../../assets/static/church/njangie_group.png";


function Church() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br><br></br>
      <EmptySlider 
        title="Church Account? We’ve got you covered." 
        description="Kontriman provides several ways to assist you with your Church account – through our help center, chat support, and email. Access the support you need, whenever and wherever you need it." 
        imageUrl={FlightImage}
    />
      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Text column */}
              <Col
                md={6}
                className="order-1 order-md-2 d-flex align-items-center"
              >
                <div>
                  <h1 className="custom_heading">Church Account</h1>
                  <p>
                    Our Church Account is designed to support religious
                    institutions in managing their finances efficiently and
                    transparently. From tithes and offerings to project funds
                    and operational expenses, this account helps your ministry
                    stay financially organized and accountable.
                  </p>

                  <h5 className="mt-4">Features & Benefits</h5>
                  <ul>
                    <li>Multi-signatory access and control</li>
                    <li>Detailed statements for accountability</li>
                    <li>Support for online giving and donations</li>
                    <li>
                      Flexible options for savings, projects, and daily
                      operations
                    </li>
                  </ul>

                  <h5 className="mt-4">Eligibility</h5>
                  <ul>
                    <li>Registered church or religious organization</li>
                    <li>Valid identification of church leadership</li>
                    <li>
                      Proof of address and church constitution (if available)
                    </li>
                    <li>Minimum number of signatories: 2</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">
                      Open Church Account
                    </Button>
                  </a>
                </div>
              </Col>

              {/* Image column */}
              <Col md={6} className="order-2 order-md-1">
                <img
                  src={churchGroupImage}
                  alt="Church Account"
                  className="img-fluid"
                />
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default Church;
